import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  firstName: yup
    .string()
    .max(40, 'Please enter no more than 40 characters')
    .required('Please enter your first name'),
  lastName: yup
    .string()
    .max(80, 'Please enter no more than 80 characters')
    .required('Please enter a last name'),
});
